import { jsx } from "react/jsx-runtime";
import { BLOCK_MAPPING } from "../../constants/blocks.esm.js";
import { AnimatedBlock } from "../BlockAnimation/BlockAnimation.esm.js";
import { stripAnimationAttrs } from "../BlockAnimation/animationConfig.esm.js";
import BlocksContext from "./BlockContext.esm.js";
import BlockErrorBoundary from "./BlockErrorBoundary.esm.js";
const renderBlock = (block, index) => {
  if (!BLOCK_MAPPING[block.blockName]) return null;
  const Mapped = BLOCK_MAPPING[block.blockName];
  const Component = (Mapped == null ? void 0 : Mapped.Component) ? Mapped.Component : Mapped;
  return /* @__PURE__ */ jsx(AnimatedBlock, { block, index, renderBlock: (domProps) => {
    const stripped = stripAnimationAttrs(block);
    return /* @__PURE__ */ jsx(BlockErrorBoundary, { blockName: block.blockName, children: /* @__PURE__ */ jsx(Component, { ...stripped, attrs: Object.keys(domProps).length ? {
      ...stripped.attrs,
      ...domProps
    } : stripped.attrs }) });
  } }, String(index));
};
const BlockList = ({
  blocks
}) => {
  return /* @__PURE__ */ jsx(BlocksContext.Provider, { value: {
    rootBlocks: blocks
  }, children: /* @__PURE__ */ jsx("div", { children: blocks.map(renderBlock) }) });
};
const generateBlockList = ({
  blocks = []
}) => {
  return blocks.map(renderBlock);
};
export {
  BlockList as default,
  generateBlockList
};
